import { Brain, Activity, Eye, AlertTriangle, TrendingUp, Shield, Zap } from "lucide-react";
import { P, SectionTitle } from "./report-utils";

export function ArchetypeTab({ archetype }) {
    return (
        <div data-testid="section-archetype">
            <SectionTitle icon={Brain} title="Archetype Profile" subtitle="Behavioral pattern and response tendencies" id="archetype" />

            <div className="rounded-xl border border-slate-100 bg-white p-6 sm:p-8 shadow-sm mb-6">
                <div className="flex flex-col sm:flex-row sm:items-center gap-4 mb-5">
                    <div className="w-14 h-14 rounded-2xl flex items-center justify-center" style={{ background: P.navy }}>
                        <Brain className="h-7 w-7 text-white" />
                    </div>
                    <div>
                        <p className="text-[0.6rem] font-bold uppercase tracking-[0.2em] text-slate-400 mb-1">Identified Archetype</p>
                        <h3 className="text-xl sm:text-2xl font-bold text-slate-900" style={{ fontFamily: "Outfit" }}>{archetype?.name}</h3>
                        <span className="inline-block mt-1 text-[0.65rem] font-bold px-2.5 py-1 rounded-full bg-slate-100 text-slate-500">{archetype?.score_range}</span>
                    </div>
                </div>
                <p className="text-sm text-slate-500 leading-relaxed italic border-l-2 border-slate-200 pl-4">{archetype?.description}</p>
            </div>

            <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {[
                    { title: "Under Pressure", key: "under_pressure", icon: Activity, color: "#6366F1", bg: "#EEF2FF" },
                    { title: "Processing Feedback", key: "processing_feedback", icon: Eye, color: "#0891B2", bg: "#ECFEFF" },
                    { title: "What Blocks Growth", key: "what_blocks_growth", icon: AlertTriangle, color: P.amber, bg: P.amberBg, highlight: "warning" },
                    { title: "Growth Triggers", key: "growth_triggers", icon: TrendingUp, color: P.green, bg: P.greenBg, highlight: "success" },
                    { title: "Shutdown Triggers", key: "shutdown_triggers", icon: Shield, color: P.red, bg: P.redBg },
                    { title: "Predicted ROI", key: "predicted_roi", icon: Zap, color: "#7C3AED", bg: "#F5F3FF" },
                ].map(({ title, key, icon: Icon, color, bg, highlight }) => {
                    const text = archetype?.[key];
                    if (!text) return null;
                    return (
                        <div key={key} className={`rounded-xl border bg-white p-5 shadow-sm ${highlight === "warning" ? "border-amber-200" : highlight === "success" ? "border-emerald-200" : "border-slate-100"}`}>
                            <div className="flex items-center gap-2.5 mb-3">
                                <div className="w-7 h-7 rounded-lg flex items-center justify-center" style={{ background: bg }}>
                                    <Icon className="h-3.5 w-3.5" style={{ color }} />
                                </div>
                                <p className="text-xs font-bold uppercase tracking-wider" style={{ color }}>{title}</p>
                            </div>
                            <p className="text-sm text-slate-600 leading-relaxed">{text}</p>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
